import React, { ReactNode } from 'react'

import './index.scss';

interface ICardTitleProps {
  title?: string
  titleClassName?: String
  subTitle?: string | ReactNode
  subTitleClassName?: String
  subTitleColor?: string
  backgroundColor?: string
}

const CardTitle: React.SFC<ICardTitleProps> = (props: ICardTitleProps) => {
  const { title, titleClassName, subTitle, subTitleClassName, subTitleColor, backgroundColor } = props;
  const cardTitleClass = `lazycat-card-title ${titleClassName || ""}`;
  const cardSubTitleClass = `lazycat-card-subTitle ${subTitleClassName || ""}`;
  return (
    <div style={{ backgroundColor: backgroundColor }}>
      <div className={cardTitleClass}>{title}</div>
      <div style={{ color: subTitleColor }} className={cardSubTitleClass}>{subTitle}</div>
    </div>
  )
}

export default CardTitle;